import solana from "../assets/icons/solana.png";
import etherium from "../assets/icons/ethereum.png";
import avalanche from "../assets/icons/avalanche.png";
import polygon from "../assets/icons/polygon.png";

export const getBlockchainCurrency = (network = "solana") => {
    if (network === "solana") {
        return "sol";
    } else if (network === "ethereum") {
        return "eth";
    } else if (network === "avalanche") {
        return "avax";
    } else if (network === "polygon") {
        return "matic";
    } else {
        return "sol";
    }
};

export const getCurrencyName = (network = "sol") => {
    if (network === "sol") {
        return "solana";
    } else if (network === "eth") {
        return "ethereum";
    } else if (network === "avax") {
        return "avalanche";
    } else if (network === "matic") {
        return "polygon";
    } else {
        return "solana";
    }
};

export const getBlockchainNetwork = (currency = "sol") => {
    if (currency === "sol" || currency === "solana") {
        return solana;
    } else if (currency === "eth" || currency === "ethereum") {
        return etherium;
    } else if (currency === "avax" || currency === "avalanche") {
        return avalanche;
    } else if (currency === "matic" || currency === "polygon") {
        return polygon;
    } else {
        return solana;
    }
};
